import { ajax } from '../../../services/helper'
class ApiService {

    getReasonsData = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/reasons/list"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    addReasons = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/reasons/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    getReasonsById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/reasons/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     editReasons = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/reasons/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    

    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Reasons/services/apiservices.js